var _circle, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#F0B429"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3401 14.3265H15.6735V12.9932H14.3401V14.3265H9.31348V16.9932H10.6468V15.6598H14.3401V16.9932H15.6735V15.6598H19.3401V16.9932H20.6735V14.3265H20.3401Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0065 11.6732C15.927 11.6732 16.6732 10.927 16.6732 10.0065C16.6732 9.08604 15.927 8.33984 15.0065 8.33984C14.086 8.33984 13.3398 9.08604 13.3398 10.0065C13.3398 10.927 14.086 11.6732 15.0065 11.6732Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.98014 21.6605C10.9006 21.6605 11.6468 20.9143 11.6468 19.9938C11.6468 19.0733 10.9006 18.3271 9.98014 18.3271C9.05967 18.3271 8.31348 19.0733 8.31348 19.9938C8.31348 20.9143 9.05967 21.6605 9.98014 21.6605Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0065 21.6605C15.927 21.6605 16.6732 20.9143 16.6732 19.9938C16.6732 19.0733 15.927 18.3271 15.0065 18.3271C14.086 18.3271 13.3398 19.0733 13.3398 19.9938C13.3398 20.9143 14.086 21.6605 15.0065 21.6605Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0065 21.6605C20.927 21.6605 21.6732 20.9143 21.6732 19.9938C21.6732 19.0733 20.927 18.3271 20.0065 18.3271C19.086 18.3271 18.3398 19.0733 18.3398 19.9938C18.3398 20.9143 19.086 21.6605 20.0065 21.6605Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashIcon);
export default __webpack_public_path__ + "static/media/dashIcon.f0f630a64f90984896ee1295cbbf639a.svg";
export { ForwardRef as ReactComponent };